import React from 'react';
import { CommissionRun } from './pages/CommissionRun';
export function App() {
  return <CommissionRun data-id="element-0" data-mp="35ckb29dc16k1" />;
}